import { makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { ReportEffects } from './store/effects/report.effects';
import * as reportReducer from './store/reducers/report.reducer';

export function provideReportFeature() {
  return makeEnvironmentProviders([
    provideState('reportModule', reportReducer.reducer),
    provideEffects(ReportEffects),
  ]);
}
